<template>
	<div class="language-toggler dropdown" v-if="optionsForLanguage.length > 0">
		<b-dropdown variant="outline-secondary" size="sm" :text="curArrayItem.text" v-if="$screen.width >= 992">
			<b-dropdown-header id="dropdown-header-label">
				{{ FormMSG(10, 'Switch to another language') }}
			</b-dropdown-header>
			<b-dropdown-item-button v-for="lang in optionsForLanguage" :key="lang.value" action @click="changeLanguage(lang)">
				{{ lang.text }}
			</b-dropdown-item-button>
		</b-dropdown>

		<b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" v-if="$screen.width < 992" no-caret>
			<template #button-content>
				<b-button variant="outline-primary" size="sm" class="mx-0" style="width: 32px" :disabled="isLangueChangeLoading">
					<b-spinner v-if="isLangueChangeLoading" small />
					<globe-2 v-else :size="16" />
				</b-button>
			</template>
			<b-dropdown-header id="dropdown-header-label">
				{{ FormMSG(10, 'Switch to another language') }}
			</b-dropdown-header>
			<b-dropdown-item v-for="lang in optionsForLanguage" :key="lang.value" action :active="language === lang.value" @click="changeLanguage(lang)">
				{{ lang.text }}
			</b-dropdown-item>
		</b-dropdown>
	</div>
</template>

<script>
import gql from 'graphql-tag';
import { store } from '@/store';
import languageMessages from '@/mixins/languageMessages';
import { Globe2 } from 'lucide-vue';
import globalMixin from '@/mixins/global.mixin';
import { mapGetters, mapActions } from 'vuex';
import { noTilde } from '~utils';

// Variable doit être dans la query : https://github.com/graphql/graphiql/issues/156
const mutation_changeLanguage = gql`
	mutation ($LanguageId: Int!) {
		UpdAppLanguage(LanguageId: $LanguageId)
	}
`;

export default {
	name: 'HeaderLanguageToggler',
	components: { Globe2 },
	mixins: [languageMessages, globalMixin],
	data: function () {
		return {
			// Initialize your apollo data
			erreur: {},
			myerr: '',
			shared: store.state,
			language: 0,
			curArrayItem: { value: 0, text: 'English' },
			isLangueChangeLoading: false
		};
	},
	computed: {
		...mapGetters({
			isTranslator: 'config/isTranslator',
			appLanguage: 'config/appLanguage'
		}),
		getCurLanguageToDisplay() {
			return curArrayItem.text;
		},
		optionsForLanguage() {
			let langArray = [];
			if (process.env.VUE_APP_RUNNING_MODE === 'PROD' && !this.isTranslator) {
				langArray = this.FormMenu(10001);
			} else {
				langArray = this.FormMenu(1);
			}

			return langArray.sort((a, b) => {
				const aText = noTilde(a.text.trim()).toLowerCase();
				const bText = noTilde(b.text.trim()).toLowerCase();
				return aText.localeCompare(bText);
			});
		}
	},
	watch: {
		optionsForLanguage: {
			handler(newVal, oldVal) {
				// from optionForLanguage computed refactorization
				// to resolve the ESLint error "unexpected side effect in optionLanguage computed property
				if (newVal && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
					this.setCurrentLanguage(newVal);
				}
			},
			immediate: true,
			deep: true
		},
		curArrayItem: {
			handler(newVal) {
				let checkToken = store.getToken() ? store.getToken() : null;
				if (!_.isNil(checkToken)) {
					setTimeout(() => {
						localStorage.setItem('job-request-default-language-with-token', JSON.stringify(newVal));
					}, 100);
				}
				// return newVal;
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		setCurrentLanguage(langArray) {
			// from optionForLanguage computed refactorization
			// to resolve the ESLint error "unexpected side effect in optionLanguage computed property
			this.language = this.appLanguage;
			this.curArrayItem = langArray.find((item) => item.value === this.language);
		},
		async changeLanguage(newChoice) {
			if (this.$isPwa() && this.$isIOSDevice()) {
				const action = async () => {
					this.actionForChangeLanguagePWA(newChoice);
				};
				this.confirmModal(action, this.FormMSG(11, 'The app will disconnect to support changing your language. Want to continue ?'));
			} else {
				await this.actionForChangeLanguageWeb(newChoice);
			}
		},

		async actionForChangeLanguageWeb(newChoice) {
			// console.log("new choice:", newChoice);
			this.isLangueChangeLoading = true;

			for (let i = 0; i < this.optionsForLanguage.length; i++) {
				if (this.optionsForLanguage[i].value == newChoice.value) {
					this.curArrayItem = this.optionsForLanguage[i];

					this.language = this.optionsForLanguage[i].value;
					break;
				}
			}

			const LanguageId = parseInt(this.language, 10);

			await this.$apollo
				.mutate({
					mutation: mutation_changeLanguage,
					variables: {
						LanguageId
					}
				})
				.then(async (result) => {
					// console.log("new token:", result.data.UpdAppLanguage);
					await store.onNewToken(this.$apollo.provider.defaultClient, result.data.UpdAppLanguage); // executer onNewToken avant de storer le nouveau projet, sinon supprimé
					//windows.history.go()
					console.log({ 'this.$isPwa()': this.$isPwa() });

					this.myerr = '';

					this.$router.go();
				})
				.catch((error) => {
					this.erreur = error;
				});

			this.isLangueChangeLoading = false;
		},

		async actionForChangeLanguagePWA(newChoice) {
			// console.log("new choice:", newChoice);
			this.isLangueChangeLoading = true;

			for (let i = 0; i < this.optionsForLanguage.length; i++) {
				if (this.optionsForLanguage[i].value == newChoice.value) {
					this.curArrayItem = this.optionsForLanguage[i];
					this.language = this.optionsForLanguage[i].value;
					break;
				}
			}

			const LanguageId = parseInt(this.language, 10);

			await this.$apollo
				.mutate({
					mutation: mutation_changeLanguage,
					variables: {
						LanguageId
					}
				})
				.then(async (result) => {
					// console.log("new token:", result.data.UpdAppLanguage);
					store.state.myProfile.appLanguage = parseInt(this.language, 10);
					await store.onNewToken(this.$apollo.provider.defaultClient, result.data.UpdAppLanguage); // executer onNewToken avant de storer le nouveau projet, sinon supprimé
					//windows.history.go()
					console.log({ 'this.$isPwa()': this.$isPwa() });

					this.myerr = '';

					store.onLogout();
					document.location.href = '/';
				})
				.catch((error) => {
					this.erreur = error;
				});

			this.isLangueChangeLoading = false;
		}
	}
};
</script>

<style>
.language-toggler .dropdown-menu {
	/* margin: 20px; */
	padding: 0;
}
</style>
